import type { IOrganizationFilterOption, OrganizationSortKey, OrganizationViewMode } from '../interfaces';

export const ORGANIZATION_VIEW_MODES: OrganizationViewMode[] = ['grid', 'table'];

export const DEFAULT_ORGANIZATION_VIEW_MODE: OrganizationViewMode = 'table';

export const ORGANIZATION_PAGE_LIMIT = 10;

export const ORGANIZATION_SEARCH_DEBOUNCE_MS = 1000;

export const ORGANIZATION_FILTER_OPTIONS: IOrganizationFilterOption[] = [
  {
    label: 'Status',
    key: 'status',
    type: 'checkbox',
    options: ['Active', 'Pending', 'Suspended'],
  },
  {
    label: 'Company Size',
    key: 'size',
    type: 'checkbox',
    options: [
      '10-50',
      '50-100',
      '100-250',
      '250-500',
      '500-1000',
      '1000+',
      '5000+',
    ],
  },
];

export const ORGANIZATION_SORT_OPTIONS: { label: string; value: OrganizationSortKey }[] = [
  { label: 'Latest Created', value: 'latest' },
  { label: 'User Count', value: 'users' },
  { label: 'Health Score', value: 'health' },
];

export const DEFAULT_ORGANIZATION_SORT: OrganizationSortKey = 'latest';

export const SUBSCRIPTION_STATUS_COLOR_MAP: Record<string, string> = {
  active: 'bg-emerald-50 text-emerald-600 border-emerald-100',
  trialing: 'bg-amber-50 text-amber-600 border-amber-100',
  canceled: 'bg-red-50 text-red-600 border-red-100',
  past_due: 'bg-orange-50 text-orange-600 border-orange-100',
};

export const DEFAULT_SUBSCRIPTION_STATUS_CLASSES = 'bg-slate-50 text-slate-500 border-slate-100';
